import { useEffect } from 'react';

export const useResetState = (value, setValue, delay = 1000) => {
    useEffect(() => {
        if (!value) return;

        const timerId = setTimeout(() => {
            setValue(false);
        }, delay);

        return () => clearTimeout(timerId);
    }, [value, delay, setValue]);
};
